<template>
    <modal-dialog ref="modalDialog">
        <template v-slot:title>
            Pre-Qualification Link Settings
        </template>
        <template v-slot:body>
            <div v-if="isLoading" class="col-md-12 tabs d-none d-md-block">
                <loader-custom :rowCount="6" />
            </div>
            <div v-else class="container-fluid px-3">
                <!-- Appointments Section -->
                <div class="section">
                    <h5 class="section-title mb-3">Appointment Settings</h5>

                    <!-- Appointment Confirmation -->
                    <div class="setting-group">
                        <div
                            class="setting-header d-flex align-items-center justify-content-between"
                        >
                            <h6 class="setting-title mb-0">
                                Appointment Confirmation
                            </h6>
                            <div
                                class="green-toggle custom-control custom-switch"
                            >
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="confirmationToggle"
                                    v-model="settings.confirmation.enabled"
                                    @change="
                                        handleToggleChange(
                                            PQ_APPOINTMENT_CONFIRMATION
                                        )
                                    "
                                />
                                <label
                                    class="custom-control-label"
                                    for="confirmationToggle"
                                ></label>
                            </div>
                        </div>
                        <div class="setting-content">
                            <div class="setting-item">
                                Include pre-qualification link in email footer
                            </div>
                        </div>
                    </div>

                    <!-- Pre-visit -->
                    <div class="setting-group">
                        <div
                            class="setting-header d-flex align-items-center justify-content-between"
                        >
                            <h6 class="setting-title mb-0">
                                Appointment Pre-visit
                            </h6>
                            <div
                                class="green-toggle custom-control custom-switch"
                            >
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="preVisitToggle"
                                    v-model="settings.preVisit.enabled"
                                    @change="
                                        handleToggleChange(
                                            PQ_APPOINTMENT_PREVISIT
                                        )
                                    "
                                />
                                <label
                                    class="custom-control-label"
                                    for="preVisitToggle"
                                ></label>
                            </div>
                        </div>
                        <div class="setting-content">
                            <div class="setting-item">
                                Include pre-qualification link in email footer
                                and pre-visit page
                            </div>
                        </div>
                    </div>

                    <!-- Reminder -->
                    <div class="setting-group">
                        <div
                            class="setting-header d-flex align-items-center justify-content-between"
                        >
                            <h6 class="setting-title mb-0">
                                Appointment Reminder
                            </h6>
                            <div
                                class="green-toggle custom-control custom-switch"
                            >
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="reminderToggle"
                                    v-model="settings.reminder.enabled"
                                    @change="
                                        handleToggleChange(
                                            PQ_APPOINTMENT_REMINDER
                                        )
                                    "
                                />
                                <label
                                    class="custom-control-label"
                                    for="reminderToggle"
                                ></label>
                            </div>
                        </div>
                        <div class="setting-content">
                            <div class="setting-item">
                                Include pre-qualification link in email footer
                                and confirmation page
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Documents Section -->
                <div class="section">
                    <h5 class="section-title mb-3">Document Settings</h5>

                    <!-- Invoice -->
                    <div class="setting-group">
                        <div
                            class="setting-header d-flex align-items-center justify-content-between"
                        >
                            <h6 class="setting-title mb-0">Invoice Export</h6>
                            <div
                                class="green-toggle custom-control custom-switch"
                            >
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="invoiceToggle"
                                    v-model="settings.invoice.enabled"
                                    @change="
                                        handleToggleChange(PQ_INVOICE_EXPORT)
                                    "
                                />
                                <label
                                    class="custom-control-label"
                                    for="invoiceToggle"
                                ></label>
                            </div>
                        </div>
                        <div class="setting-content">
                            <div class="setting-item">
                                Include pre-qualification link in email footer
                                and QR code in invoice PDF
                            </div>
                        </div>
                    </div>

                    <!-- Estimate -->
                    <div class="setting-group">
                        <div
                            class="setting-header d-flex align-items-center justify-content-between"
                        >
                            <h6 class="setting-title mb-0">Estimate Export</h6>
                            <div
                                class="green-toggle custom-control custom-switch"
                            >
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="estimateToggle"
                                    v-model="settings.estimate.enabled"
                                    @change="
                                        handleToggleChange(PQ_ESTIMATE_EXPORT)
                                    "
                                />
                                <label
                                    class="custom-control-label"
                                    for="estimateToggle"
                                ></label>
                            </div>
                        </div>
                        <div class="setting-content">
                            <div class="setting-item">
                                Include pre-qualification link in email footer
                                and QR code in estimate PDF
                            </div>
                        </div>
                    </div>

                    <!-- Account Statements -->
                    <div class="setting-group">
                        <div
                            class="setting-header d-flex align-items-center justify-content-between"
                        >
                            <h6 class="setting-title mb-0">
                                Account Statements
                            </h6>
                            <div
                                class="green-toggle custom-control custom-switch"
                            >
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="statementToggle"
                                    v-model="settings.statement.enabled"
                                    @change="
                                        handleToggleChange(
                                            PQ_ACCOUNT_STATEMENTS
                                        )
                                    "
                                />
                                <label
                                    class="custom-control-label"
                                    for="statementToggle"
                                ></label>
                            </div>
                        </div>
                        <div class="setting-content">
                            <div class="setting-item">
                                Include pre-qualification link in email footer
                                and QR code in statement PDF
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="d-flex justify-content-end">
                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="handleClose"
                    :disabled="isSaving"
                >
                    Close
                </button>
            </div>
        </template>
    </modal-dialog>
</template>

<script>
import AccountService from "@/services/account";
import LoaderCustom from "@/components/elements/loader-custom";

export default {
    components: {
        LoaderCustom,
        ModalDialog: () => import("@/components/commons/modal-dialog.vue")
    },
    data() {
        return {
            // Pre-qualification type constants
            PQ_APPOINTMENT_CONFIRMATION: 1,
            PQ_APPOINTMENT_PREVISIT: 2,
            PQ_APPOINTMENT_REMINDER: 3,
            PQ_INVOICE_EXPORT: 4,
            PQ_ESTIMATE_EXPORT: 5,
            PQ_ACCOUNT_STATEMENTS: 6,
            settings: {
                confirmation: {
                    enabled: true
                },
                preVisit: {
                    enabled: true
                },
                reminder: {
                    enabled: true
                },
                invoice: {
                    enabled: true
                },
                estimate: {
                    enabled: true
                },
                statement: {
                    enabled: true
                }
            },
            isSaving: false,
            isLoading: false
        };
    },
    computed: {},
    methods: {
        open() {
            this.reset();
            this.loadSettings();
        },
        handleClose() {
            this.$refs.modalDialog.close();
        },
        async loadSettings() {
            try {
                this.isLoading = true;
                const response = await AccountService.getPreQualSetting(
                    this._setting.business.id
                );
                if (response?.message?.code == 200) {
                    let resource = response?.resource;

                    if (resource && resource.length > 0) {
                        // Map the array data based on pre_qual_type
                        if (Array.isArray(resource)) {
                            resource.forEach(item => {
                                switch (item.pre_qual_type) {
                                    case this.PQ_APPOINTMENT_CONFIRMATION:
                                        this.settings.confirmation.enabled =
                                            item.isactive;
                                        break;
                                    case this.PQ_APPOINTMENT_PREVISIT:
                                        this.settings.preVisit.enabled =
                                            item.isactive;
                                        break;
                                    case this.PQ_APPOINTMENT_REMINDER:
                                        this.settings.reminder.enabled =
                                            item.isactive;
                                        break;
                                    case this.PQ_INVOICE_EXPORT:
                                        this.settings.invoice.enabled =
                                            item.isactive;
                                        break;
                                    case this.PQ_ESTIMATE_EXPORT:
                                        this.settings.estimate.enabled =
                                            item.isactive;
                                        break;
                                    case this.PQ_ACCOUNT_STATEMENTS:
                                        this.settings.statement.enabled =
                                            item.isactive;
                                        break;
                                }
                            });
                        }
                    }
                    this.$refs.modalDialog.open();
                } else {
                    throw new Error("Failed to load settings");
                }
            } catch (error) {
                this._message("Failed to load settings", "error");
            } finally {
                this.isLoading = false;
            }
        },
        async handleToggleChange(type) {
            try {
                this.isSaving = true;
                let update = await AccountService.setPreQualSetting({
                    business_id: this._setting.business.id,
                    type: type,
                    isactive: this.getSettingByType(type).enabled
                });

                if (update.code !== 200) {
                    throw new Error("Failed to update settings");
                }

                this._message("Settings updated successfully", "success");
            } catch (error) {
                // Revert the toggle if save failed
                this.getSettingByType(type).enabled = !this.getSettingByType(
                    type
                ).enabled;
                this._message("Failed to update settings", "error");
            } finally {
                this.isSaving = false;
            }
        },
        getSettingByType(type) {
            switch (type) {
                case this.PQ_APPOINTMENT_CONFIRMATION:
                    return this.settings.confirmation;
                case this.PQ_APPOINTMENT_PREVISIT:
                    return this.settings.preVisit;
                case this.PQ_APPOINTMENT_REMINDER:
                    return this.settings.reminder;
                case this.PQ_INVOICE_EXPORT:
                    return this.settings.invoice;
                case this.PQ_ESTIMATE_EXPORT:
                    return this.settings.estimate;
                case this.PQ_ACCOUNT_STATEMENTS:
                    return this.settings.statement;
                default:
                    throw new Error(`Unknown setting type: ${type}`);
            }
        },
        reset() {
            this.settings = {
                confirmation: {
                    enabled: true
                },
                preVisit: {
                    enabled: true
                },
                reminder: {
                    enabled: true
                },
                invoice: {
                    enabled: true
                },
                estimate: {
                    enabled: true
                },
                statement: {
                    enabled: true
                }
            };
        }
    },
    beforeDestroy() {}
};
</script>

<style scoped>
.section {
    border-bottom: 1px solid #edf2f7;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
}

.section:last-child {
    border-bottom: none;
    margin-bottom: 0;
}

.section-title {
    color: #2d3748;
    font-size: 1.1rem;
    font-weight: 600;
}

.setting-group {
    padding: 0.5rem 0;
}

.setting-title {
    font-size: 1rem;
    font-weight: 500;
}

.setting-content {
    padding-left: 1.25rem;
    margin-top: 0.25rem;
    border-left: 1px solid #edf2f7;
}

.setting-item {
    padding: 0.15rem 3rem 0.15rem 0rem;
    color: #718096;
    font-size: 0.875rem;
}

.custom-switch {
    padding-left: 0;
    margin-left: 0.5rem;
}

.custom-switch .custom-control-label::before {
    height: 1rem;
    width: 1.75rem;
    border-radius: 0.5rem;
}

.custom-switch .custom-control-label::after {
    height: calc(1rem - 4px);
    width: calc(1rem - 4px);
    border-radius: 0.5rem;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
    transform: translateX(0.75rem);
}

.spinner-border {
    width: 1rem;
    height: 1rem;
    border-width: 0.15em;
}

.setting-group[disabled] {
    opacity: 0.7;
}

.setting-content {
    transition: opacity 0.2s ease;
}

.setting-group:hover {
    background-color: #f7fafc;
}
</style>
